module.exports = "{game_window_sessionid | translate}";